<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="page-headline">
                    <h2>{{pageTitle}}</h2>
                    <h1>{{subTitle}}</h1>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-12 tools-content d-flex justify-content-center">
                <div class="converter_box">
                    <p class="headline">Avid Resolve Markerlist Converter</p>
                    <span>Der Converter wandelt aus einer Avid MediaComposer Marker-List eine EDL für Davinci Resolve. </span>
                    <span class="moredetails" data-toggle="collapse" data-target="#converter-details" v-on:click="toggleDetails()">{{detailsText}}</span>

                    <div id="converter-details" class="collapse">
                        <span class="subheadline">How To:</span>
                        <ul>
                            <li>Exportiere deine Marker aus dem Marker-Fenster in Avid MC per Rechtsklick als TXT-File.</li>
                            <li>Lade die TXT in den Converter und speicher die erstellte EDL.  </li>
                            <li>Importiere die neue EDL in Davinci Resolve als Marker EDL.</li>
                        </ul>
                        <span class="subheadline">Technische Details:</span>
                        <ul>
                            <li>Farben und Namen werden übertragen.</li>
                            <li>Umlaute werden zur Zeit nicht untestützt.</li>
                            <li>Spanned Markers werden zur Zeit nicht unterstützt.</li>
                            <li>Die EDL wird auf dem Server nur gewandelt, nicht gespeichert.</li>
                        </ul>
                    </div>

                    <form action="https://www.robinjuenkersfeld.de/converter/converter.php" method="post" enctype="multipart/form-data">
                        <h2>Wähle hier deine
                            <br />Avid Marker List (.txt) aus:</h2>
                        <input type="file" name="UploadTxt" id="fileToUpload">
                        <br /><input type="submit" value="Umwandeln" name="submit">
                    </form>
                </div>
                </div>
        </div>
    </div>

</template>

<script>

    export default {
        name: "tools-page",
        metaInfo: {
            meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'Kleine Tools für Editing Workflows.' },
                { name: 'robots', content: 'Index' }
            ],
            title: 'Tools'
        },


        data: function() {
            return {
                pageTitle: "Tools",
                subTitle: "Converter",
                detailsText: "Mehr Infos",
                show: false,


            };

        },
        methods: {
            toggleDetails: function () {
                if(!this.show) {
                    this.openDetails();
                } else {
                    this.closeDetails();
                }
            },

            openDetails: function () {
                this.show = true;
                this.detailsText = "Weniger Infos"
             },

            closeDetails: function () {
                if(this.show) {
                    this.show = false;
                    this.detailsText = "Mehr Infos"
                }
            }


        }

    };
</script>
